import React, { useState, useEffect, ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Dispatch } from 'redux';

import { User } from '../../../types/entity.types';
import { RootState } from '../../../types/state/root.types';

import { requestRegisterSystemUser } from '../../../api/registration/registration.actions';
import { requestVerifyMemberStatus } from '../../../api/external-registration/external-registration.actions';

import Activate from '../../../components/screens/auth/activate/Activate';

const ActivateContainer = (): ReactElement => {
  const memberStatus: string | undefined = useSelector(
    (state: RootState): string | undefined => state.registration.memberStatus
  );

  const [programmeName, setProgrammeName] = useState<string | undefined>(undefined);

  const dispatch: Dispatch = useDispatch();

  const { memberExternalReference } = useParams();

  useEffect((): void => {
    // @ts-expect-error TODO: Fix after adding types to external registration actions
    dispatch(requestVerifyMemberStatus({ externalReference: memberExternalReference }));
  }, [dispatch, memberExternalReference]);

  const createSystemUser = (username: string, password: string): void => {
    const user: User = {
      username,
      password,
      memberExternalReference
    };

    dispatch(
      // @ts-expect-error TODO: Fix after adding types to registration actions
      requestRegisterSystemUser({
        input: user,
        onSuccess: (programmeName: string): void => setProgrammeName(programmeName)
      })
    );
  };

  return <Activate createSystemUser={createSystemUser} programmeName={programmeName} memberStatus={memberStatus} />;
};

export default ActivateContainer;
